import { Card, Footer, Header, Main, PlainSkeleton } from "@/components";

export function ElevatorSkeleton() {
  return (
    <>
      <Header>エレベーターを設定</Header>
      <Main>
        <Card>
          <PlainSkeleton />
        </Card>
      </Main>
      <Footer />
    </>
  );
}
